<div class="content-block">
  <article class="article " style="margin-top:1rem">

    <div class="back-container borderless">
      <button class="btn btn-back" (click)="back()"><i class="fas fa-caret-left"></i> Back</button>
    </div>

    <div class="input-column">
      <table>
        <tr>
          <td><label  style="margin-right: 1vw;">Customer Site Name</label ></td>
          <td> <input type="text"  [(ngModel)]="location.name" /></td>
        </tr>
        <tr>
          <td><label  style="margin-right: 1vw;">Address Line 1</label ></td>
          <td> <input type="text"  [(ngModel)]="location.address_1" /></td>
        </tr>

        <tr>
          <td><label  style="margin-right: 1vw;">Address Line 2</label ></td>
          <td> <input type="text"  [(ngModel)]="location.address_2" /></td>
        </tr>
        <tr>
          <td><label  style="margin-right: 1vw;">Address Line 3</label ></td>
          <td> <input type="text"  [(ngModel)]="location.address_3" /></td>
        </tr>
        <tr>
          <td><label  style="margin-right: 1vw;">Address Line 4</label ></td>
          <td> <input type="text"  [(ngModel)]="location.address_4" /></td>
        </tr>
        <tr>
          <td><label  style="margin-right: 1vw;">Postcode</label ></td>
          <td> <input type="text"  [(ngModel)]="location.postcode" /></td>
        </tr>

        <tr>
          <td><label  style="margin-right: 1vw;">Contact Name</label ></td>
          <td> <input type="text"  [(ngModel)]="location.contact_Name" />
          </td>
        </tr>

        <tr>
          <td><label  style="margin-right: 1vw;">Contact Phone</label></td>
          <td> <input type="text"  [(ngModel)]="location.contact_Phone" />
          </td>
        </tr>
        <tr>
          <td><label  style="margin-right: 1vw;">Contact Email</label ></td>
          <td> <input type="text"  [(ngModel)]="location.contact_Email" />
          </td>
        </tr>
        <tr>
          <td><label  style="margin-right: 1vw;">Expired</label ></td>
          <td> <input type="checkbox" id="switch-1" name="switch-1" role="switch" [(ngModel)]="location.expired" />
          </td>
        </tr>

      </table>
    </div>
    <div class="btn-container">
      <div class="spacer" ></div>
      <button class="btn btn-primary" (click)="save()">Save</button>

    </div>

  </article>
</div>